<template>
    <Head>
        <title>Directorio</title>
    </Head>
    <div class="hero-img-overlay " style="background-image: url('/img/hero-comisiones.png');">
      <div class="container">
        <div class="row">
          <div class="col-md-6 col-lg-7">
            <h1 class="hero-encabezado">Directorio</h1>
          </div>
        </div>
      </div>
    </div>
    <div class="bloque-general">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <h2 class="encabezado-separador"><span>Estas son nuestras áreas de atención y servicio</span></h2>
          </div>
          <div class="col-md-6 col-lg-5">
            <div class="directorio-buscador">
              <form action="#">
                <div class="form-group">
                  <input class="input-buscador" v-model="search" type="text" placeholder="Buscar un departamento...">
                </div>
              </form>
            </div>
          </div>
          <div class="col-12">

            <div v-for="(item, index) in filterDirectorio" :key="index" class="item-directorio-departamento">
              <div class="item-directorio__departamento">
                <div class="departamento-nombre">{{ item.departamento }}</div>
                <div v-if="item.otros!=''" class="departamento-desglose otros" v-html="item.otros"></div>
              </div>
              <div class="item-directorio__ubicacion">
                <div class="departamento-ubicacion"><img src="/img/icono-ubicacion-dorado.svg" alt=""><span>{{ item.lugar }}</span></div>
                <div class="departamento-direccion">{{ item.ubicacion }}</div>
              </div>
              <div class="item-directorio__telefonos">
                <div class="item-telefono"><img src="/img/icono-telefono-dorado.svg" alt="">
                  <span>{{ item.telefono }}</span>
                </div>
              </div>
            </div>
            <div v-if="filterDirectorio.length < 1">
                <NoResults/>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import NoResults from "../../Shared/Utils/NoResults.vue";

export default {
    data() {
        return{
            search: '',
        }
    },
    components:{
        NoResults
    },
    props:{
        directorio: Object,
    },
    computed: {
        filterDirectorio: function () {
            return this.filterDirectorioByName(this.directorio)
        },
    },
    methods: {
        filterDirectorioByName: function (directorio) {
            return this.search
            ? directorio.filter(
                (item) => (item.otros!=null) ?
                    item.departamento.toLowerCase().includes(this.search.toLowerCase()) || item.otros.replace(/(\r\n|\n|\r)/gm, "", "").toLowerCase().includes(this.search.toLowerCase())
                    :
                    item.departamento.toLowerCase().includes(this.search.toLowerCase())
            )
            : directorio;
        },
    },
}
</script>
<style scoped>
.item-telefono, .otros{
    white-space: pre;
}
</style>
